import React from 'react';
import Box from '@mui/material/Box';
import {modalHeaderProps, modalInnerStyle} from '../../styles/modalStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MuiModal from '@mui/material/Modal';

export default function Modal({header, sx, width = 500, children, ...props}) {
  return (
    <MuiModal
      {...props}
      sx={{display: 'flex', overflowY: 'scroll', padding: '16px 0', ...sx}}
    >
      <Box sx={{...modalInnerStyle, width}} >
        <Grid container spacing={2}>
          {header ? (
            <Grid item xs={12}>
              <Typography {...modalHeaderProps}>
                {header}
              </Typography>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </MuiModal>
  );
}
